import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";

export default function LanguageSwitcher() {
  const pathname = usePathname();
  const router = useRouter();

  const locales = [
    { code: "en", name: "EN" },
    { code: "az", name: "AZ" },
    { code: "ru", name: "RU" },
  ];

  const getCurrentLocale = () => {
    const match = pathname ? pathname.match(/^\/(en|az|ru)/) : null;
    return match ? match[1] : "en";
  };

  const handleLocaleChange = (locale: string) => {
    if (pathname) {
      const newPath = pathname.replace(/^\/(en|az|ru)/, `/${locale}`);
      router.push(newPath);
    }
  };

  return (
    <div className="w-20">
      <Select
        defaultValue={getCurrentLocale()}
        onValueChange={handleLocaleChange}
      >
        <SelectTrigger className="w-full border-brand-dot-track bg-brand-cream text-brand-navy focus:ring-brand-navy focus:ring-offset-brand-cream">
          <SelectValue placeholder="Select language" />
        </SelectTrigger>
        <SelectContent className="bg-brand-cream text-brand-navy border-brand-dot-track">
          {locales.map((locale) => (
            <SelectItem key={locale.code} value={locale.code} className="focus:bg-brand-sand focus:text-brand-navy">
              {locale.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
